import axios from 'axios';
import { getRequestUrlHelper } from '~/src/helpers/get-request-url.helper';
import { defaultUrlGetToken } from '~/src/repositories/id-token/api-urls';

export const getIdTokenHttp = async () => {
    const url = getRequestUrlHelper({ isSSR: true, apiKey: defaultUrlGetToken, defaultUrl: defaultUrlGetToken });
    const result = await axios.get<string>(url);
    return result.data;
};
